import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import request from 'utils/request';

interface OptionsType {
  name: string;
}

export default function AutocompleteWithAjax({ setVariable, url, keyItem, label }:any) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<OptionsType[]>([]);
  const [loading, setLoading] = useState(false);
  const [timeoutId, setTimeoutId] = useState<number | null>(null);

  
  const fetchData = async (searchText: string) => {
    setLoading(true);
    try {
      const response = await request(`${url}${searchText}`).then((res) => res.data);
      setOptions(response.map((option: any) => {return {name:option[keyItem]}}));
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (_event:any, value:any) => {
    setOpen(true);

    if (timeoutId) {
        clearTimeout(timeoutId);
    }
    const newTimeoutId:any = setTimeout(() => {
        fetchData(value);
    }, 2000);
    setTimeoutId(newTimeoutId);

  };

  const handleSelect = (value:any) => {
    setVariable(value);
  };

  return (
    <Autocomplete
      id="autocomplete-with-ajax"
      style={{ width: 400 }}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      onInputChange={handleInputChange}
      getOptionSelected={(option, value) => option.name === value.name}
      filterOptions={x => x}
      getOptionLabel={(option) => option.name}
      options={options}
      loading={loading}
      onChange={(_evet, value) => handleSelect(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}